module.exports = __webpack_public_path__ + "assets/retina_CircleTangentCPwCenterLDetailed.c9909a539b48868fbf37907f41e618f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CircleTangentCPwCenterLDetailed.png
// module id = 647
// module chunks = 0